/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 검색 스토어
 * 버전 : 1.0
 * 파일명 : useSearchStore.ts
 * 작성자 : 강동형
 * 작성일 : 2026-01-30
 * ================================================================ 
 * ================================================================ */

import {create} from'zustand'

interface SearchState{
    totalRow : number
    pageNum : number
    setField : (field: keyof SearchState, value: any) => void 
    reset: (field?: keyof SearchState) => void
}

const defaultValue = {
    totalRow : 0,
    pageNum : 1
}

export const useSearchStore = create<SearchState>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset: (field) =>
        set((state) => {
            if (!field) {
                // 전체 초기화
                return { ...state, ...defaultValue }
            }
            // 특정 필드만 초기화
            return { ...state, [field]: defaultValue[field as keyof typeof defaultValue] }
        }),
}))